import 'core-js/es6/promise'
import 'core-js/es6/string'
import 'core-js/es7/array'

import _ from 'lodash'

import Vue from 'vue'
import VueI18n from 'vue-i18n'
import VueLocalStorage from 'vue-localstorage'
import Vuebar from 'vuebar';
import BootstrapVue from 'bootstrap-vue'
import { TooltipPlugin } from 'bootstrap-vue'
import VueNotification from 'vue-notification'
import VueModal from 'vue-js-modal'
import App from './App.vue'

import './../Libs/Broadcast'
import './../Libs/Broadcast.Dom'

import './directives/window'
import './directives/pseudo-modal'

import { Auth } from './services/Auth'
import { Metadata } from './services/Metadata'
import { Server } from './services/Server'
import { User } from './services/User'
import { Publisher } from './services/Publisher'
import { Preview } from './services/Preview'
import { Creative } from './services/Creative'
import { Banner } from './services/Banner'
import { Storyboard } from './services/Storyboard'
import { Renderer } from './services/Renderer'
import { Version } from './services/Version'
import { Settings } from './services/Settings'
import { Asset } from './services/Asset'
import { Localization } from './services/Localization'
import { Layout } from './services/Layout'
import { Notifications } from './services/Notifications'
import { Monitoring } from './services/Monitoring'
import { Template } from './services/Template'
import { Tutorial } from './services/Tutorial'
import { Elements } from './services/Elements'
import { Events } from './services/Events'
import { Animation } from './services/Animation'
import { Emitter } from './services/Emitter'
import { Testing } from './services/Testing'
import { Tracking } from './services/Tracking'
import { Access } from './services/Access'
import { File } from './services/File'
import { Cluster } from './services/Cluster'
import { AIAgent } from './services/AIAgent'

import SetupSettings	from './settings/settings'

Vue.use(Vuebar);
Vue.use(VueI18n);
Vue.use(BootstrapVue);
Vue.use(TooltipPlugin);
Vue.use(VueLocalStorage, {name: 'ls', bind: true});
Vue.use(VueNotification, {name: 'notify', componentName: 'VueNotification'});
Vue.use(VueModal, {componentName: 'VueModal'});

Vue.config.productionTip = false;

const i18n = new VueI18n({
	locale: 'en',
	fallbackLocale: 'en',
	messages: {},
});

Vue.prototype._ = _;
Vue.prototype.Metadata = Metadata;
Vue.prototype.Layout = Layout;
Vue.prototype.User = User;
Vue.prototype.Publisher = Publisher;
Vue.prototype.Preview = Preview;
Vue.prototype.Creative = Creative;
Vue.prototype.Version = Version;
Vue.prototype.Elements = Elements;
Vue.prototype.Events = Events;
Vue.prototype.ProductFeed = ProductFeed;
Vue.prototype.Testing = Testing;
Vue.prototype.Access = Access;
Vue.prototype.File = File;
Vue.prototype.Cluster = Cluster;

new Vue({
	i18n,
	render: h => h(App)
}).$mount('#vue-mount-point');

// Получаем токен (в том числе по старой сессии, оставшейся до перехода на токены) и только потом подключаемся к серверу
Auth.loadSessionToken(() => Server.connect());

Broadcast.enableDebug({
	excludeEvents: ["Document Move", "Document Press Down", "Document Press Up", "Pseudo Modal Process Hide", "Pseudo Modal Hided", "Server Data Received",
		"Document Wheel", "Document Key Up", "Document Key Down", "Document Key Press", "Pseudo Modal Hided %", "% Down", "% Up", "% Press", "Pseudo Modal Show%",
		"Pseudo Modal Hide", "Show Asset Preview", "Hide Asset Preview", "Show Creative Preview", "Hide Creative Preview", "Server Data:%", "IFrame Data:MraidSDKMethodCall",
		"Testing Step Added"],
	showEventArgs: false
});

